<mat-toolbar class="content-header">
    <mat-icon class="header-icon" fontIcon="manage_accounts"></mat-icon>

    <h1 class="page-title">{{'users.registry' | translate}}</h1>

    <span class="toolbar-spacer"></span>

    <lib-button class="add-button" icon='add' [tooltip]="'users.add_user' | translate"
        (click)="router.navigate(['/users/edit-user'])"></lib-button>

    <app-search-bar (searchText)="search($event)"></app-search-bar>
</mat-toolbar>

<ng-container>
    <div class="table-container">
        <table mat-table [dataSource]="usersData" matSort>
            <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    <div class="header-content">
                        <mat-icon fontIcon="mail"></mat-icon>
                        <span>Email</span>
                    </div>
                </th>
                <td mat-cell *matCellDef="let row"> {{row.email}} </td>
            </ng-container>

            <ng-container matColumnDef="company">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    <div class="header-content">
                        <mat-icon fontIcon="business"></mat-icon>
                        <span>Company</span>
                    </div>
                </th>
                <td mat-cell *matCellDef="let row"> {{row.company}} </td>
            </ng-container>

            <ng-container matColumnDef="project">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    <div class="header-content">
                        <mat-icon fontIcon="folder"></mat-icon>
                        <span>Projects</span>
                    </div>
                </th>
                <td mat-cell *matCellDef="let row" class="project-column">
                    <div *ngIf="row.projects" class="chips">
                        <lib-chip color="muted" size="small" *ngFor="let project of row.projects | orderByName"
                            text="{{project.name}}">
                        </lib-chip>
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>
                    <div class="header-content">
                        <mat-icon fontIcon="settings"></mat-icon>
                        <span>Actions</span>
                    </div>
                </th>
                <td mat-cell *matCellDef="let row">
                    <div *ngIf="canEdit()" class="action-buttons">
                        <lib-button [icon]="'edit'" [textColor]="'secondary'" color="none" (click)="editUser(row.id)">
                        </lib-button>
                        <lib-button [icon]="'delete'" [textColor]="'danger'" color="none" (click)="deleteUser(row)">
                        </lib-button>
                    </div>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="usersColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: usersColumns;"></tr>

            <tr class="mat-row no-data-row" *matNoDataRow>
                <td class="mat-cell" [attr.colspan]="usersColumns.length">
                    <lib-no-data message="form.search_no_data" description="form.search_no_data_desc" icon="search_off">
                    </lib-no-data>
                </td>
            </tr>
        </table>

        <mat-paginator #userPaginator [length]="usersCount" [pageSize]="10" [pageSizeOptions]="[10, 25, 100]"
            class="paginator" (page)="handlePageEvent($event)">
        </mat-paginator>

        <div *ngIf="loading" class="table-overlay">
            <app-spinner></app-spinner>
        </div>
    </div>
</ng-container>